import Reveal from "./Reveal";

export default function SectionHeading({ index, eyebrow, title, sub }) {
  return (
    <Reveal className="mb-12 lg:mb-16">
      <div className="flex items-center gap-3 mb-5 flex-wrap">
        <span className="font-mono text-xs tracking-[0.3em] text-hpink">{index}</span>
        <span className="h-px w-12 bg-gradient-to-r from-hpink to-horange" />
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-hdim">{eyebrow}</span>
      </div>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95]">
        {title}
      </h2>
      {sub ? <p className="mt-5 max-w-2xl text-hmut text-base sm:text-lg leading-relaxed">{sub}</p> : null}
    </Reveal>
  );
}
